import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 640px;
`;

const Th80 = styled(ThItem)`
  width: 80px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Th160 = styled(ThItem)`
  width: 160px;
`;

const Header = props => {
  
  return (
    <THead>
      <TableRow>
        <Th120>員工名稱</Th120>
        <Th120>打卡日期</Th120>
        <Th160>上班打卡時間</Th160>
        <Th160>下班打卡時間</Th160>
        <Th80></Th80>
      </TableRow>
    </THead>
  );
};

export default Header;